import { Component, ElementRef, Input } from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';
import { gsap, Quad } from 'gsap';

@Component({
    selector: 'app-day-buttons-list',
    templateUrl: './day-buttons-list.component.html',
    styleUrls: ['./day-buttons-list.component.scss']
})
export class DayButtonsListComponent {

    @Input('color1') color1: string
    @Input('color2') color2: string
    @Input('color3') color3: string
    @Input('color4') color4: string
    @Input('isMobile') isMobile: boolean

    public position: number = 0

    constructor(
        public apiService: ApiService,
        private elRef: ElementRef
    ) {

    }

    selectDay(index: number) {
        let dayID = this.apiService.daysList[index].id
        this.apiService.selectDay(dayID)
        this.scrollToDateList()
    }

    private scrollToDateList() {
        const dateList = (this.elRef.nativeElement as HTMLElement).closest('.dateList') as HTMLElement;
        const sectionList = document.querySelector('.selectionView') as HTMLElement
        const title =  document.querySelector('app-header') as HTMLElement
        if (!dateList) return;

        let top = 0;
        let el: HTMLElement = dateList;
        while (el) {
            top += el.offsetTop;
            el = el.offsetParent as HTMLElement;
        }
        let el2: HTMLElement = sectionList;
        // while (el2) {
            top = el2.offsetTop - dateList.getBoundingClientRect().height - title.getBoundingClientRect().height
        // }s
        if(this.isMobile) {
            top = top + 30;
        }

        const header = document.querySelector('app-header') as HTMLElement;
        const headerHeight = header ? header.clientHeight : 0;
        window.scrollTo({ top: top, behavior: 'smooth' });
    }

    onLeft() {
        gsap.to('.dayButtonsSlider', 0.5, {x: '0vw', ease: Quad.easeOut});
    }

    onRight() {
        gsap.to('.dayButtonsSlider', 0.5, {x: '-31vw', ease: Quad.easeOut});
    }
}
